import Particles from './modules/Particles'

new Particles(document.getElementById('particles'))